import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Engines from "../pages/engines/page";
import Transmissions from "../pages/transmissions/page";
import BodyParts from "../pages/body-parts/page";
import ContactUs from "../pages/contact/page";
import ProductDetail from "../pages/product/page";
import Testimonials from "../pages/testimonials/page";
import ReturnPolicy from "../pages/return-policy/page";
import Terms from "../pages/terms/page";
import Admin from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/engines",
    element: <Engines />,
  },
  {
    path: "/transmissions",
    element: <Transmissions />,
  },
  {
    path: "/body-parts",
    element: <BodyParts />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "/product/:id",
    element: <ProductDetail />,
  },
  {
    path: "/testimonials",
    element: <Testimonials />,
  },
  {
    path: "/return-policy",
    element: <ReturnPolicy />,
  },
  {
    path: "/terms-and-conditions",
    element: <Terms />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;